
import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Globe } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

export const LanguageSelector = () => {
  const { t, changeLanguage, getCurrentLanguage } = useTranslation();
  const currentLang = getCurrentLanguage();

  const languages = [
    { code: 'en', name: t('languages.english'), flag: '🇺🇸' },
    { code: 'es', name: t('languages.spanish'), flag: '🇪🇸' },
  ];

  return (
    <div className="flex items-center gap-2">
      <Globe size={16} className="text-gray-600" />
      <div className="flex gap-1">
        {languages.map((lang) => (
          <Button
            key={lang.code}
            size="sm"
            variant={currentLang === lang.code ? "default" : "outline"}
            onClick={() => changeLanguage(lang.code)}
            className="h-7 px-2 text-xs"
          >
            <span className="mr-1">{lang.flag}</span>
            {lang.name}
          </Button>
        ))}
      </div>
      <Badge variant="secondary" className="text-xs">
        v1.3.0
      </Badge>
    </div>
  );
};
